import { render, staticRenderFns } from "./ArchivedProductsListTab.vue?vue&type=template&id=57331a6a"
import script from "./ArchivedProductsListTab.vue?vue&type=script&lang=js"
export * from "./ArchivedProductsListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports